<div class="welcome">

    <div class="column">
        Welcome to WIRE

    </div>
</div>